"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.Options = exports.Level = void 0;
var pino_1 = __importDefault(require("pino"));
var Level;
(function (Level) {
    Level[Level["silent"] = 0] = "silent";
    Level[Level["trace"] = 10] = "trace";
    Level[Level["debug"] = 20] = "debug";
    Level[Level["info"] = 30] = "info";
    Level[Level["warn"] = 40] = "warn";
    Level[Level["error"] = 50] = "error";
    Level[Level["fatal"] = 60] = "fatal";
})(Level = exports.Level || (exports.Level = {}));
var Options = (function () {
    function Options(consoleOnly, level) {
        this.consoleOnly = consoleOnly;
        this.level = level;
    }
    return Options;
}());
exports.Options = Options;
var internalLogger = (0, pino_1.default)();
var LoggerImpl = (function () {
    function LoggerImpl(options) {
        this.options = options;
    }
    LoggerImpl.prototype.setConsoleOnly = function (consoleOnly) {
        this.options.consoleOnly = consoleOnly;
    };
    LoggerImpl.prototype.silent = function (_m) { };
    LoggerImpl.prototype.trace = function (m) {
        if (this.options.level <= Level.trace) {
            if (this.options.consoleOnly) {
                console.log(m);
            }
            else {
                internalLogger.trace(m);
            }
        }
    };
    LoggerImpl.prototype.debug = function (m) {
        if (this.options.level <= Level.debug) {
            if (this.options.consoleOnly) {
                console.log(m);
            }
            else {
                internalLogger.debug(m);
            }
        }
    };
    LoggerImpl.prototype.info = function (m) {
        if (this.options.level <= Level.info) {
            if (this.options.consoleOnly) {
                console.info(m);
            }
            else {
                internalLogger.info(m);
            }
        }
    };
    LoggerImpl.prototype.warn = function (m) {
        if (this.options.level <= Level.warn) {
            if (this.options.consoleOnly) {
                console.warn(m);
            }
            else {
                internalLogger.warn(m);
            }
        }
    };
    LoggerImpl.prototype.error = function (m) {
        if (this.options.level <= Level.error) {
            if (this.options.consoleOnly) {
                console.error(m);
            }
            else {
                internalLogger.error(m);
            }
        }
    };
    LoggerImpl.prototype.fatal = function (m) {
        if (this.options.level <= Level.fatal) {
            if (this.options.consoleOnly) {
                console.error(m);
            }
            else {
                internalLogger.fatal(m);
            }
        }
    };
    LoggerImpl.prototype.always = function (m) {
        console.log(m);
    };
    LoggerImpl.prototype.setLevel = function (l) {
        this.options.level = l;
        switch (l) {
            case Level.silent:
                internalLogger.level = 'silent';
                break;
            case Level.trace:
                internalLogger.level = 'trace';
                break;
            case Level.debug:
                internalLogger.level = 'debug';
                break;
            case Level.info:
                internalLogger.level = 'info';
                break;
            case Level.warn:
                internalLogger.level = 'warn';
                break;
            case Level.error:
                internalLogger.level = 'error';
                break;
            case Level.fatal:
                internalLogger.level = 'fatal';
                break;
            default:
                internalLogger.level = 'info';
        }
    };
    return LoggerImpl;
}());
exports.logger = new LoggerImpl(new Options(false, Level.info));
//# sourceMappingURL=Logger.js.map